export default __webpack_public_path__ + "static/media/MaduroTorpedo.f70cfa3c.png";